import { render } from "./MessageManager.vue?vue&type=template&id=f3b38d62"
import script from "./MessageManager.vue?vue&type=script&lang=js"
export * from "./MessageManager.vue?vue&type=script&lang=js"

import "./MessageManager.vue?vue&type=style&index=0&id=f3b38d62&lang=less"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__